// extracted by mini-css-extract-plugin
export var loadingShimmer = "_s7-2";
export var messageContent = "_s7-0";
export var messagesScroll = "_s7-1";
export var shimmer = "_s7-3";
export var shimmerW100 = "_s7-4";
export var shimmerW70 = "_s7-8";
export var shimmerW80 = "_s7-7";
export var shimmerW85 = "_s7-6";
export var shimmerW90 = "_s7-5";